// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".payment-loader[data-v-df5255ae]{background:var(--white)}\n", "",{"version":3,"sources":["webpack://./src/components/Session/Account/PaymentsLoader.vue"],"names":[],"mappings":"AACA,iCACC,uBAAwB","sourcesContent":["\n.payment-loader {\n\tbackground: var(--white);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
